import { RESERVING_DEAL_STATUSES, type DealStatus } from './deals.schemas';

/** The slice of a deal the rule reads; `DealListItem` and `DealResponse` both satisfy it. */
export type OrderableDeal = { readonly id: string; readonly status: DealStatus; readonly createdAt: string };

/** Open = still reserving the Objekt: Entwurf, Aktiv, Zurückgestellt. Closed = Gewonnen, Verloren. */
export function isOpenDealStatus(status: DealStatus): boolean {
  return (RESERVING_DEAL_STATUSES as ReadonlyArray<DealStatus>).includes(status);
}

/** Open before closed, newest `createdAt` first inside each group, `id` ascending on a tie. New array. */
export function orderDealsOfProperty<T extends OrderableDeal>(deals: ReadonlyArray<T>): ReadonlyArray<T> {
  return [...deals].sort(
    (a, b) =>
      Number(isOpenDealStatus(b.status)) - Number(isOpenDealStatus(a.status)) ||
      Date.parse(b.createdAt) - Date.parse(a.createdAt) ||
      (a.id < b.id ? -1 : a.id > b.id ? 1 : 0),
  );
}

/** „The current Deal": the open deal, else the most recent closed one; null when none. */
export function currentDealOfProperty<T extends OrderableDeal>(deals: ReadonlyArray<T>): T | null {
  return orderDealsOfProperty(deals)[0] ?? null;
}
